import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import { Button } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Button/Button';
import { Text } from '../../../../../builder-io/storyblocks-design-system/components/atoms/Text/Text';
import { selectStockItemEdited } from '../../../../ContentEdit/ContentEditSlice';

const Loader = () => {
  const numDots = 8;
  const [activeDot, setActiveDot] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setActiveDot((prevActiveDot) => (prevActiveDot + 1) % numDots);
    }, 500); // Adjust speed here (in milliseconds)

    // Cleanup interval on component unmount
    return () => clearInterval(interval);
  }, []);

  const dots = Array.from({ length: numDots }, (_, index) => {
    // Calculate the rotation and translation for each dot
    const rotation = (360 / numDots) * index;
    const transformStyle = {
      transform: `rotate(${rotation}deg) translate(40px) rotate(-${rotation}deg)`,
    };

    return (
      <div
        key={index}
        className={`absolute w-4 h-4 rounded-full transition-all duration-100 ease-linear opacity-60 ${
          index === activeDot ? 'bg-black' : 'bg-white'
        }`}
        style={transformStyle}
      ></div>
    );
  });

  return (
    <div className="relative w-16 h-16 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
      {dots}
    </div>
  );
};

function VideoEditLoad({ handleClose }: { handleClose: () => void }) {
  const editedStockItem = useSelector(selectStockItemEdited);
  const imageUrl = editedStockItem?.mediumImageUrl || '';
  return (
    <div className="flex flex-col text-center items-center gap-6 p-4">
      <div>
        <Text fontSize="lg">Your Video is generating...</Text>
        <Text fontSize="sm" fontWeight="regular" className="m-0 max-w-xl">
          Your generation may take a few minutes. Close this window to return to
          search - you&apos;ll get a notification once your video is ready!
        </Text>
      </div>
      <div
        className="relative rounded-2xl"
        style={{
          boxShadow:
            '0 0 10px 5px #fff, 0 0 10px 10px #f0f, 0 0 10px 10px #0ff',
        }}
      >
        <img
          className="rounded-2xl"
          src={imageUrl}
          alt="Video thumbnail for content being generated"
        />
        <div className="absolute inset-0 bg-black bg-opacity-50 rounded-2xl">
          <Loader />
        </div>
      </div>
      <Button onClick={handleClose}>Back to Search</Button>
    </div>
  );
}

export default VideoEditLoad;
